'use client';
import isEmpty from 'lodash.isempty';
import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import { compact } from './compact.js';

const getUrlString = (url, queryParams, useHash) => {
    if (isEmpty(queryParams)) {
        return url;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-argument */
    const paramsString = Object.entries(omitBy(queryParams, isNil))
        .map(([key, value]) => {
        if (Array.isArray(value)) {
            return value
                .filter(compact)
                .map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
                .join('&');
        }
        else {
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
    })
        .join('&');
    /* eslint-enable @typescript-eslint/no-unsafe-argument */
    const char = '?';
    return `${url}${url.includes(char) ? '&' : char}${paramsString}`;
};

export { getUrlString };
//# sourceMappingURL=get-url-string.js.map
